export default __webpack_public_path__ + "static/media/filled_heart.9cd3e129.svg";